<template>
  <div class="panel-body">
    <div id="shipping-status-inquiry" class="flexbox gap-15 flex-content-start" style="flex-wrap: nowrap;">
      <div class="filter">
        <form autocomplete="off"  class="w-210">
          <div class="form-group">
            <label class="control-label label-normal">出荷管理番号</label>
            <input type="text" class="form-control" v-model.trim="filter.shippingNo" @keydown.enter="filterShipping">
          </div>
          <div class="form-group">
            <label class="control-label label-normal">出荷ID</label>
            <input type="text" class="form-control" v-model.trim="filter.shippingId" @keydown.enter="filterShipping">
          </div>
          <div class="form-group">
            <label class="control-label label-normal">ASIN</label>
            <input type="text" class="form-control" v-model.trim="filter.asin" @keydown.enter="filterShipping">
          </div>
          <div class="form-group">
            <label class="control-label label-normal">SKU</label>
            <input type="text" class="form-control" v-model.trim="filter.sku" @keydown.enter="filterShipping">
          </div>
          <div class="form-group">
            <label class="control-label label-normal">商品ラベル</label>
            <input type="text" class="form-control" v-model.trim="filter.fnsku" @keydown.enter="filterShipping">
          </div>
          <div class="form-group">
            <label class="control-label label-normal">出荷依頼日</label>
            <date-picker
              v-model="filter.dateOrder"
              placeholder=""
              ref="datepickerStart"
              format="YYYY/MM/DD"
              :input-attr="{id: 'create-date'}"
              :lang="lang"
            ></date-picker>
          </div>
          <span class="control-label label-normal">出荷ステータス</span><br>
          <div class="pd-l-10 pd-t-10">
            <div v-for="item in wareHouseStatusOption" :key="item" class="form-check">
              <input type="checkbox" name="warehouseStatus" :value="item" class="form-check-input" :id="'warehouseStatus-' + item"
                v-model="filter.warehouseStatus">
              <label class="form-check-label" :for="'warehouseStatus-' + item">{{ item }}</label>
            </div>
          </div>
          <span class="control-label label-normal">表示</span><br>
          <div class="pd-l-10 pd-t-10">
            <div class="form-check">
              <input type="checkbox" name="warehouseStatus" class="form-check-input" id="show-delete-item-ckb"
                v-model="filter.isShowDelete">
              <label class="form-check-label" for="show-delete-item-ckb">削除明細を表示する</label>
            </div>
          </div>
          <div class="flexbox gap-10 mr-t-15">
            <button type="button" class="btn btn-primary w-100" @click="filterShipping">検索</button>
            <button type="button" class="btn w-100" @click="clearFilter">クリア</button>
          </div>
        </form>
      </div>
      <div class="">
        <div class="flexbox justify-between">
          <span class="count">{{ pageData.length }} 件</span>
          <pagination
            :totalPage="totalPage"
            :currentPage="currentPage"
            :paginationStorageKey="paginationStorageKey"
            @updateCurrentPage="updateCurrentPage"
          />
        </div>
        <div class="table-outter">
          <div class="table-header">
            <table class="">
              <thead>
                <tr>
                  <th class="w-120"></th>
                  <th class="text-left w-180">区分</th>
                  <th class="text-left w-250">出荷管理番号（出荷ID）</th>
                  <th class="text-left w-300">出荷名（依頼番号）</th>
                  <th class="text-left w-160">出荷依頼日（出荷日）</th>
                  <th class="text-left w-200">出荷ステータス</th>
                  <th class="w-220"></th>
                </tr>
              </thead>
            </table>
          </div>
          <div v-if="displayData.length > 0" v-for="(item, index) in displayData" :key="index" class="table-group mr-t-15" :class="{ 'deleted': item.isDeleted }"
              :id="'table-group-' + item.shippingId + '-' + item.shippingNo">
            <table style="table-layout: fixed;">
              <tbody>
                <tr>
                  <td class="text-center w-120">
                    <button class="btn btn-expand w-100" data-toggle="collapse" :id="'btn-expand-' + item.shippingId + '-' + item.shippingNo" :data-target="'#' + item.shippingId + '-' + item.shippingNo" @click="handleExpand(item.shippingId, item.shippingNo)" :disabled="item.shippingGoods.length === 0">
                      <i class="fa fa-plus" aria-hidden="true"></i> 開く
                    </button>
                    <button class="btn btn-collapse w-100 hidden" data-toggle="collapse" :id="'btn-collapse-' + item.shippingId + '-' + item.shippingNo" :data-target="'#' + item.shippingId + '-' + item.shippingNo" @click="handleCollapse(item.shippingId, item.shippingNo)">
                      <i class="fa fa-minus" aria-hidden="true"></i> 閉じる
                    </button>
                  </td>
                  <td class="text-left w-180">
                    {{ getShippingKbnText(item.shippingKbn) }}
                  </td>
                  <td class="text-left w-250">
                    {{ item.shippingNo }} <br>
                    ({{ item.shippingId }})
                  </td>
                  <td class="text-left w-300" style="word-break: break-all;">
                    {{ item.shippingName }} <br>
                    {{ item.requestNo && "(" + item.requestNo + ")" }}
                  </td>
                  <td class="text-left w-160">
                    {{ formatDate(item.dateOrder) }} <br>
                    {{ item.shippingDate && '(' + formatDate(item.shippingDate) + ')' }}
                  </td>
                  <td class="text-size-16 text-left w-200">
                    <span class="register-processing" :class="getStatusTextClass(item.status)">
                      {{ item.status }}
                    </span>
                    <div class="tooltip-wrapper" v-if="item.status === '自動キャンセル'">
                      <i class="fa fa-info-circle text-red text-size-20" aria-hidden="true"></i>
                      <span class="tooltip-text">{{ item.waitForConfirmReason }}</span>
                    </div>
                    <div v-if="checkStatus(item.status)" class="shipping-status" :class="getStatusClass(item.status)"></div>
                  </td>
                  <td class="text-left w-220">
                    <div class="flexbox gap-5 justify-right">
                      <button type="button" class="btn btn-primary w-80 check-maintenace" @click="openModalDeliveyInfo(item)">出荷情報</button>
                      <div class="btn-group">
                        <button type="button" class="btn btn-primary dropdown-toggle" data-toggle="dropdown" aria-expanded="false">
                          操作
                          <span class="caret"></span>
                        </button>
                        <ul class="dropdown-menu" role="menu" @click.stop>
                          <li class="check-maintenance" :class="item.disableCopy ? 'disabled' : ''" :disabled="item.disableCopy" @click="openConfirmCoppyModal(item)">複製する</li>
                          <li class="check-maintenance" :class="item.disableDelete ? 'disabled' : ''" :disabled="item.disableDelete" @click="openConfirmDeleteModal(item)">削除する</li>
                        </ul>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
            <div v-if="item.shippingGoods.length" :id="item.shippingId + '-' + item.shippingNo" class="collapse table-item" style="background-color: #fff; margin: 0 10px 10px 10px;">
              <table class="full-width" style="table-layout: fixed;">
                <thead>
                  <tr>
                    <th class="text-center w-150">出荷する商品</th>
                    <th></th>
                    <th class="text-right w-150">出荷予定数</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="product in item.shippingGoods" :key="product.itemId">
                    <td class="text-center w-150">
                        <div v-if="product.image" class="box-selected-product-image w-50">
                            <img loading="lazy" :src="product.image"
                                alt="" class="selected-product-image img-responsive">
                        </div>
                        <div v-if="product.status_str" class="box-delivery-judgment-status" :class="getJudgmentStatusClass(product.status_str)">{{ product.status_str }}</div>
                    </td>
                    <td class="text-left">
                      <span>{{ product.itemName }}</span>
                      <br>
                      <span><b>ASIN：</b>{{ product.asin }} / <b>SKU：</b>{{ product.sku }}</span>
                      <br>
                      <span><b>商品ID：</b>{{ product.itemId }} / <b>商品ラベル：</b>{{ product.fnsku }}</span>
                    </td>
                    <td class="text-right text-size-20 font-bold">
                      <span>{{ formatNumber(product.quantity) }}</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div v-if="displayData.length === 0" class="table-group text-center text-danger no-data">
              データが見つかりません。
          </div>
        </div>
      </div>
    </div>
    <modal-alert
      v-if="openAlertShippingDeletedModal"
      :message="successDeleteMessage"
      :customHide="true"
      @close="closeModalAlertDeleted"
    />
    <modal-confirm
      v-if="openModalConfirmDelete"
      :message="confirmDeleteMessage"
      @confirm="handleDelete()"
      @close="closeConfirmDeleteModal()"
    />
    <modal-confirm
      v-if="openModalConfirmCoppyDelivery"
      :message="confirmCoppyMessage"
      @confirm="handleCoppy()"
      @close="closeConfirmCoppyModal()"
    />
    <shipping-info-modal
      v-if="openShippingInfoModal"
      :selectShipping="selectItem"
      @close="closeModalShippingInfo"
    />
  </div>
</template>

<script>
import Util from '@/common/utility'
import DatePicker from 'vue2-datepicker'
import moment from 'moment'
import WarehouseScService from '@/services/warehousescservice'
import ModalConfirm from '@/components/ModalConfirm'
import ModalAlert from '@/components/ModalAlert'
import ShippingInfoModal from '@/view/warehouseSc/components/ShippingInfoModal'
import Pagination from '@/components/PaginationNextPage'
import EventService from '@/services/eventservice'
import eventCode from '@/common/event-code'

export default {
  components: {
    DatePicker,
    ShippingInfoModal,
    ModalAlert,
    ModalConfirm,
    Pagination
  },
  computed: {
    paginationStorageKey () {
      return 'scShippingList'
    },
    maxRows () {
      return this.$store.getters.getPaginationRow(this.paginationStorageKey)
    }
  },
  data () {
    return {
      wareHouseStatusOption: ['出荷待ち', '出荷準備中', '出荷済', '自動キャンセル'],
      filter: {
        shippingNo: '',
        shippingId: '',
        asin: '',
        sku: '',
        fnsku: '',
        dateOrder: '',
        warehouseStatus: ['出荷待ち', '出荷準備中', '出荷済', '自動キャンセル'],
        isShowDelete: false
      },
      lang: {
        days: ['日', '月', '火', '水', '木', '金', '土'],
        months: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
        pickers: ['1週間後', '1ヶ月後', '1週間前', '1ヶ月前'],
        placeholder: {
          date: '日付を選択',
          dateRange: '期間を選択'
        }
      },
      defaultData: [],
      pageData: [],
      displayData: [],
      openModalConfirmDelete: false,
      openShippingInfoModal: false,
      openModalConfirmCoppyDelivery: false,
      openAlertShippingDeletedModal: false,
      selectItem: {},
      confirmDeleteMessage: 'この出荷指示を削除してもよろしいですか？',
      successDeleteMessage: '出荷指示を削除しました。',
      confirmCoppyMessage: `出荷情報を複製します。 <br>
                            よろしければOKボタンを選択してください。<br>
                            OKボタン選択後は、出荷依頼作成画面に遷移します。`,
      deleteFailedMessage: `
              <b class='text-red'>
              <i class='fa fa-exclamation-triangle text-size-20 mr-r-10' aria-hidden='true'></i>出荷指示を削除することができません。</b>
              <br>
              ご指定いただいた出荷指示は、出荷準備中、または出荷済のため削除することができません。
            `,
      totalPage: 1,
      currentPage: 1
    }
  },
  created () {
    this.getShippingList()
  },
  methods: {
    async getShippingList () {
      this.loader = this.$loading.show()
      await WarehouseScService.getShippingList()
        .then((response) => {
          this.defaultData = response.data
          this.pageData = this.defaultData.filter(item => {
            return item.isDeleted === this.filter.isShowDelete
          })
          this.sliceDisplayData()
        })
        .catch((error) => {
          this.$events.fire('handleError', error)
        })
        .finally(() => {
          this.loader && this.loader.hide()
        })
    },
    sliceDisplayData () {
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          this.totalPage = Math.ceil(this.pageData.length / this.maxRows)
          if (this.totalPage > 0 && this.currentPage > this.totalPage) {
            this.currentPage = 1
          }
          this.displayData = this.pageData.slice((this.currentPage - 1) * this.maxRows, this.currentPage * this.maxRows)
          this.loader && this.loader.hide()
        }, 300)
      })
    },
    handleCoppy () {
      this.closeConfirmCoppyModal()
      let routeUrl = null
      switch (this.selectedItem.shippingKbn) {
        case '02':
          routeUrl = this.$router.resolve({
            name: 'Warehouse sc',
            params: {
              tab: 'shipping',
              subTab: 'multi-channel'
            },
            query: {
              shippingId: this.selectedItem.shippingId,
              shippingNo: this.selectedItem.shippingNo
            }
          }).href
          break
        default:
          return false
      }

      let logParams = {
        name: eventCode.warehouse_sc.shipping_tab.list.click_coppy_btn,
        properties: {
          shippingId: this.selectedItem.shippingId,
          shippingNo: this.selectedItem.shippingNo
        }
      }

      EventService.postTrackLog(logParams)
      this.$router.push(routeUrl)
    },
    formatDate (value) {
      return value ? moment(value).format('YYYY/MM/DD') : ''
    },
    handleExpand (id, no) {
      $('#table-group-' + id + '-' + no).addClass('expand')
      $('#btn-expand-' + id + '-' + no).addClass('hidden')
      $('#btn-collapse-' + id + '-' + no).removeClass('hidden')
    },
    handleCollapse (id, no) {
      $('#table-group-' + id + '-' + no).removeClass('expand')
      $('#btn-expand-' + id + '-' + no).removeClass('hidden')
      $('#btn-collapse-' + id + '-' + no).addClass('hidden')
    },
    openModalDeliveyInfo (item) {
      this.selectItem = item
      this.openShippingInfoModal = true
      let logParams = {
        name: eventCode.warehouse_sc.shipping_tab.list.click_show_shipping_info_btn,
        properties: {
          shippingNo: item.shippingNo,
          shippingId: item.shippingId
        }
      }
      EventService.postTrackLog(logParams)
    },
    closeModalShippingInfo () {
      this.openShippingInfoModal = false
      $('#shipping-info-modal').modal('hide')
    },
    openConfirmDeleteModal (item) {
      if (item.disableDelete) {
        return false
      }

      this.loader = this.$loading.show()
      let params = {
        shippingNo: item.shippingNo,
        shippingId: item.shippingId
      }

      WarehouseScService.getShippingMultichannelStatus(params)
        .then((response) => {
          if (response.data.status !== '出荷待ち') {
            this.defaultData = this.defaultData.map(item => {
              if (item.shippingNo === response.data.shippingNo && item.shippingId === response.data.shippingId) {
                return {...item, status: response.data.status}
              }
              return item
            })
            this.pageData = this.pageData.map(item => {
              if (item.shippingNo === response.data.shippingNo && item.shippingId === response.data.shippingId) {
                return {...item, status: response.data.status}
              }
              return item
            })
            this.displayData = this.displayData.map(item => {
              if (item.shippingNo === response.data.shippingNo && item.shippingId === response.data.shippingId) {
                return {...item, status: response.data.status}
              }
              return item
            })
            this.$events.fire('handleError', this.deleteFailedMessage)
          } else {
            this.selectItem = item
            this.openModalConfirmDelete = true
          }
        })
        .catch((error) => {
          this.$events.fire('handleError', error)
        })
        .finally(() => {
          this.loader && this.loader.hide()
        })
    },
    closeConfirmDeleteModal () {
      this.openModalConfirmDelete = false
      $('#delete-alert').modal('hide')
    },
    openConfirmCoppyModal (item) {
      if (item.disableCopy) {
        return false
      }
      this.selectedItem = item
      this.openModalConfirmCoppyDelivery = true
    },
    closeConfirmCoppyModal () {
      $('#confirm-alert').modal('hide')
      this.openModalConfirmCoppyDelivery = false
    },
    openModalAlertDeleted () {
      this.openAlertShippingDeletedModal = true
    },
    closeModalAlertDeleted () {
      this.openAlertShippingDeletedModal = false
      $('#myModal').modal('hide')
    },
    filterShipping () {
      let logParams = {
        name: eventCode.warehouse_sc.shipping_tab.list.click_search_btn,
        properties: {}
      }
      EventService.postTrackLog(logParams)

      this.loader = this.$loading.show()
      setTimeout(() => {
        const {
          shippingNo,
          shippingId,
          asin,
          sku,
          fnsku,
          dateOrder,
          warehouseStatus,
          isShowDelete
        } = this.filter
        const allStatusesSelected = warehouseStatus.length === this.wareHouseStatusOption.length
        const lower = str => str.toLowerCase()
        const matchIncludes = (target, keyword) => lower(target || '').includes(lower(keyword || ''))

        this.pageData = [...this.defaultData].filter(item => {
          if (!isShowDelete && item.isDeleted) return false

          if (shippingNo && !matchIncludes(item.shippingNo, shippingNo)) return false

          if (shippingId && !matchIncludes(item.shippingId, shippingId)) return false

          if (asin && !(item.shippingGoods.some(product => matchIncludes(product.asin, asin)))) return false

          if (sku && !(item.shippingGoods.some(product => matchIncludes(product.sku, sku)))) return false

          if (fnsku && !(item.shippingGoods.some(product => matchIncludes(product.fnsku, fnsku)))) return false

          if (dateOrder && this.formatDate(item.dateOrder) !== this.formatDate(dateOrder)) return false

          if (!allStatusesSelected && !warehouseStatus.includes(item.status)) return false

          return true
        })
        this.sliceDisplayData()
      }, 500)
    },
    clearFilter () {
      this.loader = this.$loading.show()
      this.filter = {
        shippingKbn: ['01', '02', '03', '04'],
        shippingId: '',
        asin: '',
        sku: '',
        fnsku: '',
        dateOrder: '',
        warehouseStatus: ['出荷待ち', '出荷準備中', '出荷済', '自動キャンセル'],
        isShowDelete: false
      }
      this.pageData = [...this.defaultData].filter(item => {
        return item.isDeleted === this.filter.isShowDelete
      })
      this.sliceDisplayData()
    },
    getShippingKbnText (shippingKbn) {
      const shippingKbnMap = {
        '02': 'マルチチャネル出荷'
      }
      return shippingKbnMap[shippingKbn]
    },
    getStatusTextClass (status) {
      if (status === '自動キャンセル') {
        return 'register-processing-error'
      }
      if (status === '出荷準備中') {
        return 'register-processing-inprogress'
      }

      return ''
    },
    checkStatus (status) {
      const showStatus = ['出荷待ち', '出荷準備中', '出荷済']
      return showStatus.includes(status)
    },
    getStatusClass (status) {
      if (status === '出荷待ち') {
        return 'awaiting-shipping'
      }
      if (status === '出荷準備中') {
        return 'preparing-to-ship'
      }
      if (status === '出荷済') {
        return 'shipped'
      }
    },
    getJudgmentStatusClass (status) {
      let statusStop = ['停止中', '削除済']
      let statusSuccess = ['出品中']
      let statusWarning = ['未審査', '審査中']
      let statusDanger = ['出品NG', '審査NG']
      if (!status) {
        return ''
      }
      if (statusSuccess.includes(status)) {
        return 'judgment-status-success'
      }
      if (statusWarning.includes(status)) {
        return 'judgment-status-warning'
      }
      if (statusDanger.includes(status)) {
        return 'judgment-status-danger'
      }
      if (statusStop.includes(status)) {
        return 'judgment-status-stop'
      }
    },
    formatNumber (number) {
      return Util.formatMoney(number)
    },
    handleDelete () {
      if (this.selectItem.disableDelete || this.selectItem.shippingKbn !== '02') {
        this.closeConfirmDeleteModal()
        return false
      }
      this.deleteShippingMultichannel()
    },
    async deleteShippingMultichannel () {
      this.closeConfirmDeleteModal()
      this.loader = this.$loading.show()
      let params = {
        shippingNo: this.selectItem.shippingNo,
        shippingId: this.selectItem.shippingId
      }

      let logParams = {
        name: eventCode.warehouse_sc.shipping_tab.list.click_delete_btn,
        properties: params
      }
      EventService.postTrackLog(logParams)

      await WarehouseScService.deleteShippingMultichannel(params)
        .then((response) => {
          if (response.data.shippingId && response.data.shippingNo) {
            this.defaultData = this.defaultData.map(item => {
              if (item.shippingId === response.data.shippingId && item.shippingNo === response.data.shippingNo) {
                return {
                  ...item,
                  status: '削除済',
                  isDeleted: true,
                  disableDelete: true
                }
              }
              return item
            })
            this.pageData = this.pageData.filter(item => {
              if (item.shippingId === response.data.shippingId && item.shippingNo === response.data.shippingNo) {
                item.status = '削除済'
                item.isDeleted = true
                item.disableDelete = true
              }
              if (!this.filter.isShowDelete && item.isDeleted) return false
              return true
            })
            this.sliceDisplayData()
          }
          this.openModalAlertDeleted()
        })
        .catch((error) => {
          this.$events.fire('handleError', error)
        })
        .finally(() => {
          this.loader && this.loader.hide()
        })
    },
    updateCurrentPage (val) {
      this.loader = this.$loading.show()
      this.currentPage = val
      this.sliceDisplayData()
    }
  },
  mounted () {
    let logParams = {
      name: eventCode.warehouse_sc.shipping_tab.list.show,
      properties: {}
    }
    EventService.postTrackLog(logParams)
  },
  watch: {
    maxRows () {
      this.loader = this.$loading.show()
      this.sliceDisplayData()
    }
  }
}
</script>
<style scoped>
.judgment-status-stop {
  background-color: #a6a6a6;
  color: #f2f2f2;
}
.judgment-status-danger {
  background-color: #c00000;
  color: #fff;
}
.panel-body {
  padding: 10px 0;
}
.control-label {
  color: #595959;
}
.filter {
  padding: 10px;
  background-color: #fff;
  border: 1px solid #ccc;
  height: auto;
  box-sizing: content-box;
}
.form-check-label {
  padding-left: 5px;
  font-weight: unset;
}
.table-outter {
  margin-top: 5px;
  overflow: hidden;
  width: 1440px;
  padding-bottom: 90px;
}
.table-header {
  table-layout: fixed;
  border: 1px solid #ccc;
  position: sticky;
  top: 0;
  z-index: 1;
  background: #deebf7;
}
.table-header th {
  padding: 5px 10px;
  margin: 0 10px;
  color: #595959;
  background: #deebf7;
}

.table-header td {
  padding: 5px;
  height: 50px;
}
.text-danger {
  font-weight: unset;
}
.btn.disabled {
  background-color: #efefef;
  color: #000;
  border: 1px solid #ccc;
}
.table-item th{
  background-color: #fff;
  color: #000;
  font-weight: bold;
  border: none;
  border-bottom: 2px solid #008cc6;
  padding: 0 5px;
  z-index: -1;
}
.table-item td {
  border-bottom: 1px solid #ccc;
}
.table-group {
  background-color: #fff;
  border: 1px solid #ccc;
  vertical-align: middle;
}
.table-group td {
  padding: 5px 10px;
  height: 50px;
}
.table-group > tr.collapse td {
  background-color: red;
}
.table-group.expand {
  background-color: #deebf7;
}
.table-group.deleted {
  background-color: #ccc;
}
.btn-expand {
  color: #008cc6;
  border: 1px solid #008cc6;
  background-color: #fff;
}
.btn-collapse {
  color: #000;
  background-color: #bfbfbf;
  border: 1px solid #ccc;
}
.box-selected-product-image {
  margin: 0 auto;
}
.shipping-status {
  width: 90px;
  height: 10px;
  border-radius: 4px;
  border: 1px solid #bfbfbf;
}
.awaiting-shipping {
  background-color: #f2f2f2;
}
.preparing-to-ship {
  background-color: #ffd428;
}
.shipped {
  background-color: #70ad47;
}
.register-processing {
  padding: 2px;
}
.register-processing-error {
  color: #ff0000;
}
.register-processing-inprogress {
  color: #a6a6a6;
}
.judgment-status-not-listed {
  color: #f2f2f2;
  background-color: #a6a6a6;
}
.no-data {
  background-color: rgb(242, 222, 222);
}
.w-280 {
  width: 280px !important;
}
.w-300 {
  width: 300px !important;
}
.w-270 {
  width: 270px !important;
}
.w-210 {
  width: 210px !important;
}
.mx-datepicker {
  width: 100%;
}
.dropdown-menu {
  min-width: 100px;
  max-width: 110px;
  left: unset !important;
  right: 0;
  font-size: 14px;
  padding: unset;
}
.dropdown-menu li {
  height: 30px;
  padding: 3px 5px;
  line-height: 24px;
}
.dropdown-menu li:hover {
  cursor: default;
  background-color: #deebf7;
}
.dropdown-menu > li.disabled {
  color: #bfbfbf;
  pointer-events: none;
}
#shipping-status-inquiry {
  overflow-y: auto;
}
.fa-info-circle:hover {
  cursor: pointer;
}
.tooltip-wrapper {
  position: relative;
  display: inline-block;
  cursor: pointer;
}

.tooltip-text {
  visibility: hidden;
  background-color: #555;
  color: #fff;
  text-align: center;
  padding: 6px 10px;
  border-radius: 6px;
  font-size: 12px;
  position: absolute;
  z-index: 1;
  bottom: 125%;
  left: 50%;
  transform: translateX(-50%);
  opacity: 0;
  transition: opacity 0.3s;
  white-space: nowrap;
}

.tooltip-text::after {
  content: '';
  position: absolute;
  top: 100%;
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: #555 transparent transparent transparent;
}

.tooltip-wrapper:hover .tooltip-text {
  visibility: visible;
  opacity: 1;
}
@media (max-width: 1920px) {
  .table-outter {
    width: 1440px;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/warehouseSc/ShippingStatusInquiry.vue